import React, {useState, useEffect} from "react";
import axios from "axios";

const GeoCurrency = ({setCurrency, setCountry}) => {
    const [zone, setZone] = useState({countryName: "", continentCode: ""})

    const getGeoInfo = async () => {
        await axios.get('https://ipapi.co/json/')
            .then(response => {
                let data = response.data;
                setZone({
                    countryName: data.country_name,
                    continentCode: data.in_eu
                })
                setCountry(data.country_name);
                setCurrency(data.in_eu);
            }).catch((error) => {
                console.log(error);
            })
    }

    useEffect(() => {
        getGeoInfo().then()
    }, [])

    return (
        <div>
            {/*<p>Country name: {zone.countryName}</p>*/}
            {/*<p>Continent code: {zone.continentCode}</p>*/}
        </div>
    )
}

export default GeoCurrency;